import { useApplicationField } from '../useApplicationField';

// ─── Entity ───────────────────────────────────────────────────────────────────

export const useBorrowerEntityId = () =>
    useApplicationField(
        (d) => d.information.borrower.entity.id,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, entity: { ...d.information.borrower.entity, id: v } } } })
    );

export const useBorrowerEntityName = () =>
    useApplicationField(
        (d) => d.information.borrower.entity.name,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, entity: { ...d.information.borrower.entity, name: v } } } })
    );

export const useBorrowerEntityTypeId = () =>
    useApplicationField(
        (d) => d.information.borrower.entity.typeId,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, entity: { ...d.information.borrower.entity, typeId: v } } } })
    );

export const useBorrowerEntityStateIncorporated = () =>
    useApplicationField(
        (d) => d.information.borrower.entity.stateIncorporated,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, entity: { ...d.information.borrower.entity, stateIncorporated: v } } } })
    );

export const useBorrowerEntityStreet1 = () =>
    useApplicationField(
        (d) => d.information.borrower.entity.address.street1,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, entity: { ...d.information.borrower.entity, address: { ...d.information.borrower.entity.address, street1: v } } } } })
    );

export const useBorrowerEntityStreet2 = () =>
    useApplicationField(
        (d) => d.information.borrower.entity.address.street2,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, entity: { ...d.information.borrower.entity, address: { ...d.information.borrower.entity.address, street2: v } } } } })
    );

export const useBorrowerEntityCity = () =>
    useApplicationField(
        (d) => d.information.borrower.entity.address.city,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, entity: { ...d.information.borrower.entity, address: { ...d.information.borrower.entity.address, city: v } } } } })
    );

export const useBorrowerEntityState = () =>
    useApplicationField(
        (d) => d.information.borrower.entity.address.state,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, entity: { ...d.information.borrower.entity, address: { ...d.information.borrower.entity.address, state: v } } } } })
    );

export const useBorrowerEntityZipCode = () =>
    useApplicationField(
        (d) => d.information.borrower.entity.address.zipCode,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, entity: { ...d.information.borrower.entity, address: { ...d.information.borrower.entity.address, zipCode: v } } } } })
    );

export const useBorrowerEntity = () =>
    useApplicationField(
        (d) => d.information.borrower.entity,
        (d, v) => ({ ...d, information: { ...d.information, borrower: { ...d.information.borrower, entity: v } } })
    );
